import React, { useMemo } from 'react';
import { ISelectOption } from '../base';
import {
    AssignableUser,
    formatAssignableUserLabel,
} from '../../services/worker-configuration/worker-configuration.users';
import * as S from './configuration-rule.styles';

interface IConfigurationAssignedUsersProps {
    assignedBankUserIds: string[];
    disabled?: boolean;
    loading?: boolean;
    onChange: (bankUserIds: string[]) => void;
    users: AssignableUser[];
}

export const ConfigurationAssignedUsers: React.FC<IConfigurationAssignedUsersProps> = ({
    assignedBankUserIds,
    disabled,
    loading,
    onChange,
    users,
}) => {
    const userOptions: ISelectOption<string>[] = useMemo(
        () =>
            users.map(user => ({
                value: user.bankUserId,
                label: formatAssignableUserLabel(user),
            })),
        [users],
    );

    const selectedOptions = useMemo(
        () =>
            assignedBankUserIds.map(bankUserId => {
                const option = userOptions.find(candidate => candidate.value === bankUserId);
                return option ?? { value: bankUserId, label: bankUserId };
            }),
        [assignedBankUserIds, userOptions],
    );

    return (
        <S.FieldSelect
            isMulti
            closeMenuOnSelect={false}
            options={userOptions}
            value={selectedOptions}
            placeholder={loading ? 'Loading users…' : 'Select assignees…'}
            disabled={disabled || loading}
            onChange={selected => {
                const options = Array.isArray(selected) ? selected : selected ? [selected] : [];
                onChange(
                    options
                        .map(option => String(option.value ?? ''))
                        .filter(Boolean),
                );
            }}
        />
    );
};
